import React from "react";
import axios from "@/utils/myaxios";
import Cookie from 'js-cookie'
import moment from "moment";
import { Link } from "react-router-dom";
import {
    Button,
    Table,
    message,
    Row,
    Col,
    Card,
    InputNumber,
    Spin,
    Modal,
    Form,
    Tabs,
    Empty,
    Pagination,
} from "antd";
import { statusList4, kindList } from "@/utils/constant";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class GameCurrencyTypeProportion extends React.Component {
    state = {
        loading: false, // 是否加载中
        effectiveRecordLoading: false, // 生效记录是否加载中
        publishRecordLoading: false, // 发布记是否加载中
        formData: { // 表单数据
            avail_fee_rate: undefined,
            avail_ins_rate: undefined,
            avail_cowboy_rate: undefined,
            api_prop_cost_rate: undefined,
            ins_mod: undefined,
            cowboy_mod: undefined,
        },
        effectiveRecordQueryParams: {
            // 生效记录查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        publishRecordQueryParams: {
            // 发布记录查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        proportionConfigData: [], // 比例配置数据
        effectiveRecord: [], // 生效记录
        publishRecord: [], // 发布记录
    };

    componentDidMount () {
        this.fetchProportionConfigData();
        this.fetchEffectiveRecord();
        this.fetchPublishRecord();
    }

    /**
     * 获取例配置数据
     */
    fetchProportionConfigData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/coin/last_pub_rate")
            .then((res) => {
                this.setState({
                    loading: false,
                    proportionConfigData: res.data || [],
                });
            });
    }

    /**
     * 获取生效记录
     */
    fetchEffectiveRecord = () => {
        this.setState({ effectiveRecordLoading: true });
        axios
            .get("/v1/api/coin/effect_rate_list", {
                params: {
                    ...this.state.effectiveRecordQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    effectiveRecordLoading: false,
                    effectiveRecordQueryParams: { ...this.state.effectiveRecordQueryParams, total: res.count || 0 },
                    effectiveRecord: res.data || [],
                });
            });
    }

    /**
     * 获取发布记录
     */
    fetchPublishRecord = () => {
        this.setState({ publishRecordLoading: true });
        axios
            .get("/v1/api/coin/pub_rate_list", {
                params: {
                    ...this.state.publishRecordQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    publishRecordLoading: false,
                    publishRecordQueryParams: { ...this.state.publishRecordQueryParams, total: res.count || 0 },
                    publishRecord: res.data || [],
                });
            });
    }

    /**
     * 发布
     */
    handlePublish = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                Modal.confirm({
                    title: this.props.language['hint'],
                    content: this.props.language['publishConfirm'],
                    onOk: () => {
                        axios
                            .post("/v1/api/coin/pub_new_rate", [...values.proportionConfigData])
                            .then((res) => {
                                if (res.code === 1) {
                                    message.success(this.props.language["publishSuccessMessage"]);
                                    this.fetchProportionConfigData();
                                    this.fetchEffectiveRecord();
                                    this.fetchPublishRecord();
                                }
                            });
                    },
                })
            }
        });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "effectiveRecord") {
            // 流水数据
            this.setState(
                {
                    effectiveRecordQueryParams: {
                        ...this.state.effectiveRecordQueryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchEffectiveRecord()
            );
        } else if (type === "publishRecord") {
            // 表格数据
            this.setState(
                {
                    publishRecordQueryParams: {
                        ...this.state.publishRecordQueryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchPublishRecord()
            );
        }
    };

    render () {
        return (
            <Row gutter={10} className='p10'>
                {/* 比例配置 */}
                <Col span={isMobileDevice() ? 24 : 8} className="mb10">
                    <Card
                        title={
                            <h2>
                                {this.props.language["proportionConfig"]}
                            </h2>
                        }
                        type="inner"
                    >
                        <Spin spinning={this.state.loading}>
                            <ConfigForm
                                {...this.props}
                                proportionConfigData={this.state.proportionConfigData}
                                handlePublish={this.handlePublish}
                                wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                            />
                        </Spin>
                    </Card>
                </Col>

                {/* 配置记录 */}
                <Col span={isMobileDevice() ? 24 : 16} className="mb10">
                    <Card
                        title={
                            <h2>
                                {this.props.language["configRecord"]}
                            </h2>
                        }
                        type="inner"
                    >
                        <Tabs>
                            {/* 生效记录 */}
                            <Tabs.TabPane tab={this.props.language["effectiveRecord"]} key="effectiveRecord">
                                {this.state.effectiveRecord.length > 0 &&
                                    <>
                                        <Tabs>
                                            {this.state.effectiveRecord.map((item, index) =>
                                                <Tabs.TabPane tab={`${item.begin_date} ~ ${item.end_date}`} key={index}>
                                                    <Table
                                                        dataSource={item.coin_rate_list}
                                                        pagination={false}
                                                        loading={this.state.effectiveRecordLoading}
                                                        scroll={{ x: true }}
                                                        rowKey={(record, index) => index}
                                                    >
                                                        <Table.Column
                                                            align="center"
                                                            title={this.props.language["proxyPlatformTokenType"]}
                                                            dataIndex="currency_name"
                                                        />
                                                        <Table.Column
                                                            align="center"
                                                            title={this.props.language["proportion"]}
                                                            dataIndex="currency_rate"
                                                        />
                                                        {Cookie.get("isAce1") !== 'true' &&
                                                            <Table.Column
                                                                align="center"
                                                                title={this.props.language["usdt"]}
                                                                dataIndex="usdt_rate"
                                                            />
                                                        }
                                                    </Table>
                                                </Tabs.TabPane>
                                            )}
                                        </Tabs>
                                        <Row type="flex" justify="end">
                                            <Pagination
                                                className="pagination mt10"
                                                showQuickJumper
                                                showSizeChanger
                                                size={isMobileDevice() ? 'small' : ''}
                                                showTotal={(total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                                                }
                                                pageSizeOptions={["10", "20", "30", "40"]}
                                                current={this.state.effectiveRecordQueryParams.page}
                                                pageSize={this.state.effectiveRecordQueryParams.limit}
                                                total={this.state.effectiveRecordQueryParams.total}
                                                onChange={(current, pageSize) =>
                                                    this.hanldeChangePage({ current, pageSize }, 'effectiveRecord')
                                                }
                                                onShowSizeChange={(current, pageSize) =>
                                                    this.hanldeChangePage({ current, pageSize }, 'effectiveRecord')
                                                }
                                            />
                                        </Row>
                                    </>
                                }

                                {/* 暂无数据 */}
                                {!this.state.effectiveRecord.length && (
                                    <>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                    </>
                                )}
                            </Tabs.TabPane>

                            {/* 发布记录 */}
                            <Tabs.TabPane tab={this.props.language["publishRecord"]} key="publishRecord">
                                {this.state.publishRecord.length > 0 &&
                                    <>
                                        <Tabs>
                                            {this.state.publishRecord.map((item, index) =>
                                                <Tabs.TabPane tab={
                                                    <>
                                                        <p>{`${item.begin_date} ~ ${item.end_date}`}</p>
                                                        <p style={{ textAlign: 'center' }}>{item.create_time}</p>
                                                    </>
                                                } key={index}>
                                                    <Table
                                                        dataSource={item.coin_rate_list}
                                                        pagination={false}
                                                        loading={this.state.publishRecordLoading}
                                                        scroll={{ x: true }}
                                                        rowKey={(record, index) => index}
                                                    >
                                                        <Table.Column
                                                            align="center"
                                                            title={this.props.language["proxyPlatformTokenType"]}
                                                            dataIndex="currency_name"
                                                        />
                                                        <Table.Column
                                                            align="center"
                                                            title={this.props.language["proportion"]}
                                                            dataIndex="currency_rate"
                                                        />
                                                        {Cookie.get("isAce1") !== 'true' &&
                                                            <Table.Column
                                                                align="center"
                                                                title={this.props.language["usdt"]}
                                                                dataIndex="usdt_rate"
                                                            />
                                                        }
                                                    </Table>
                                                </Tabs.TabPane>
                                            )}
                                        </Tabs>
                                        <Row type="flex" justify="end">
                                            <Pagination
                                                className="pagination"
                                                showQuickJumper
                                                showSizeChanger
                                                size={isMobileDevice() ? 'small' : ''}
                                                showTotal={(total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                                                }
                                                pageSizeOptions={["10", "20", "30", "40"]}
                                                current={this.state.publishRecordQueryParams.page}
                                                pageSize={this.state.publishRecordQueryParams.limit}
                                                total={this.state.publishRecordQueryParams.total}
                                                onChange={(current, pageSize) =>
                                                    this.hanldeChangePage({ current, pageSize }, 'publishRecord')
                                                }
                                                onShowSizeChange={(current, pageSize) =>
                                                    this.hanldeChangePage({ current, pageSize }, 'publishRecord')
                                                }
                                            />
                                        </Row>
                                    </>
                                }

                                {/* 暂无数据 */}
                                {!this.state.publishRecord.length && (
                                    <>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                    </>
                                )}
                            </Tabs.TabPane>
                        </Tabs>
                    </Card>
                </Col>
            </Row>
        );
    }
}

/**
 * 配置表单
 */
const ConfigForm = Form.create({ name: "config_form" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Form>
                    <Row className="mb20 pt10">
                        <Col span={6} style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                            <h4>{this.props.language["proxyPlatformTokenType"]}</h4>
                        </Col>
                        <Col span={Cookie.get("isAce1") !== 'true' ? 9 : 18} style={{ textAlign: "center", color: 'rgba(0, 0, 0, 0.85)' }}>
                            <h4>{this.props.language["proportion"]}</h4>
                        </Col>
                        {Cookie.get("isAce1") !== 'true' &&
                            <Col span={9} style={{ textAlign: "center", color: 'rgba(0, 0, 0, 0.85)' }}>
                                <h4>{this.props.language["usdt"]}</h4>
                            </Col>
                        }
                    </Row>
                    {this.props.proportionConfigData.map((item, index) =>
                        <Row gutter={20} key={index}>
                            <Col span={6} >
                                <Form.Item label={item.currency_name}>
                                    {getFieldDecorator(`proportionConfigData[${index}].currency_code`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["proxyPlatformTokenTypeVerify"],
                                            },
                                        ],
                                        initialValue: item.currency_code,
                                    })(
                                        <></>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={Cookie.get("isAce1") !== 'true' ? 9 : 18}>
                                <Form.Item>
                                    {getFieldDecorator(`proportionConfigData[${index}].currency_rate`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["proportionVerify"],
                                            },
                                            {
                                                pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)?(?:\.\d+)?$/,
                                                message: this.props.language["proportionVerify1"],
                                            },
                                        ],
                                        initialValue: Number(item.currency_rate),
                                    })(
                                        <InputNumber
                                            min={0}
                                            max={99999999999999.999999}
                                            placeholder={this.props.language["proportionPlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            {Cookie.get("isAce1") !== 'true' &&
                                <Col span={9}>
                                    <Form.Item>
                                        {getFieldDecorator(`proportionConfigData[${index}].usdt_rate`, {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["uVerify"],
                                                },
                                                {
                                                    pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)?(?:\.\d+)?$/,
                                                    message: this.props.language["uVerify1"],
                                                },
                                            ],
                                            initialValue: Number(item.usdt_rate),
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={99999999999999.999999}
                                                placeholder={this.props.language["uPlaceholder"]}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            }
                        </Row>
                    )}
                    <Row type="flex" justify="end" align="middle">
                        <Col>
                            <Button type="primary" onClick={this.props.handlePublish}>
                                {this.props.language["publish"]}
                            </Button>
                        </Col>
                    </Row>
                </Form >
            );
        }
    }
);
